module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58b1d982ce69a8bac44df0c5235be675.png";